import { render, staticRenderFns } from "./KitchenOrders.vue?vue&type=template&id=5454325d&scoped=true&"
import script from "./KitchenOrders.vue?vue&type=script&lang=js&"
export * from "./KitchenOrders.vue?vue&type=script&lang=js&"
import style0 from "./KitchenOrders.vue?vue&type=style&index=0&id=5454325d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454325d",
  null
  
)

export default component.exports